var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _c('hr'), _c('b-card-group', {
    attrs: {
      "columns": ""
    }
  }, [_c('b-card', {
    staticClass: "mt-4",
    attrs: {
      "title": "Tienen su propio juego de mesa",
      "img-src": require("@/assets/img/funkoverse.png"),
      "img-alt": "Image",
      "img-top": ""
    }
  }, [_c('b-card-text', [_vm._v(" Tantas son las licencias que dispone que Funko ya se ha montado su propio universo con un curioso juego de mesa llamado FunkoVerse, reuniendo una variedad de personajes tales como Batman, Harry Potter o incluso Rick y Morty. ")])], 1), _c('b-card', {
    attrs: {
      "header": "Donde nacen ?"
    }
  }, [_c('blockquote', {
    staticClass: "blockquote mb-0"
  }, [_c('p', [_vm._v(" Un 23 de octubre de 1998 se lanzó en Estados Unidos unas figuras conocidas como Funko Pops. ")]), _c('footer', {
    staticClass: "blockquote-footer"
  }, [_vm._v(" pequeñas figuras cabezonas "), _c('cite', {
    attrs: {
      "title": "Source Title"
    }
  }, [_vm._v("del personaje que quieras")])])])]), _c('b-card', {
    staticClass: "mt-4",
    attrs: {
      "title": "Pueden llegar a precios de 13.300 dólares",
      "img-src": require("@/assets/img/caros.png"),
      "img-alt": "Image",
      "img-top": ""
    }
  }, [_c('b-card-text', [_vm._v(" Hoy día hay ciertas figuras que valen una fortuna, ya sea porque se lanzaron pocas tiradas en su momento o porque directamente se realizó una edición especial de la misma. Dentro de los Funko Pops más exclusivos que son casi imposibles de conseguir encontramos figuras como Loki, con un valor de más de 1.000 dólares, un Green Lantern que brilla en la oscuridad por un valor de hasta 2.400 dólares o la joya de la corona, una figura del personaje de La naranja mecánica Alex DeLarge que brilla en la oscuridad, cuyo precio llega a los 13.300 dólares. ")]), _c('b-card-text', {
    staticClass: "small text-muted"
  }, [_vm._v("Last updated 3 mins ago")])], 1), _c('b-card', {
    attrs: {
      "bg-variant": "primary",
      "text-variant": "white"
    }
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v(" Su edificio situado en Everett, Washington, tiene una tienda en la planta baja de más de 5.000 metros cuadrados, con zonas temáticas basadas en las franquicias más populares, como Star Wars o Harry Potter. ")])])]), _c('b-card', {
    staticClass: "mt-4"
  }, [_c('b-card-title', [_vm._v("Mike Becker creador funko pop")]), _c('b-card-text', [_vm._v(" los orígenes de los Funko Pops tienen lugar en la franquicia Bob's Big Boy, una cadena de hamburguesas que tuvo un enorme éxito en Estados Unidos. ")]), _c('b-card-text', {
    staticClass: "small text-muted"
  }, [_vm._v("compro la licencia de Bob y produjo su funko ")])], 1), _c('b-card', {
    attrs: {
      "img-src": require("@/assets/img/funko1.png"),
      "img-alt": "funko1",
      "overlay": ""
    }
  }), _c('b-card', {
    attrs: {
      "img-src": require("@/assets/img/funko2.png"),
      "img-alt": "Image",
      "img-top": ""
    }
  }, [_c('b-card-text', [_vm._v(" No fue hasta que lanzaron las figuras de Juego de Tronos y The Walking Dead cuando los fans ya empezaron a coger bastante cariño a las figuras Funko Pop ")])], 1)], 1)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', {
    staticClass: "funko-home-title mt-5"
  }, [_vm._v("Curiosidades")])]);
}]

export { render, staticRenderFns }